// extracted by mini-css-extract-plugin
export default {"wrapper":"FileInput_wrapper__4HKm+","input-wrapper":"FileInput_input-wrapper__12MEF","icon":"FileInput_icon__CmE6N","realInput":"FileInput_realInput__A1tsA"};